/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import { styled, useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Divider from "@mui/material/Divider";
import RequirementInput from "./requirementInput";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import IconButton from "@mui/material/IconButton";
import PropTypes from "prop-types";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const StyledButton = styled((props) => <Button {...props} />)(({ theme }) => ({
  width: "125px",
  height: "32px",
  margin: "0px",
  color: theme.palette.custom.buttonTextColor,
  backgroundColor: theme.palette.custom.buttonColor,
  borderColor: theme.palette.custom.borderColor,
  borderWidth: "1px",
  borderStyle: "solid",
  "&:hover": {
    backgroundColor: theme.palette.custom.buttonHoverColor,
    color: theme.palette.custom.buttonHoverTextColor,
    boxShadow: "none",
  },
}));
const StyledBoxButton = styled((props) => <IconButton {...props} />)(
  ({ theme }) => ({
    backgroundColor: theme.palette.custom.buttonColor,
    borderRadius: "4px",
    border: `1px solid ${theme.palette.custom.borderColor}`,
    // display: "flex",
    // justifyContent: "center",
    width: "46px",
    height: "32px",
    padding: "5px 12px",
    marginRight: "5px",
  })
);
export default function RequirementComponent({
  requirement,
  groupIndex,
  handleTriggerDeleteGroup,
  handleChangeInput,
  handleAddInput,
  handleDeleteGroupInput,
  handleTriggerEditGroup,
  handleAddInputOption,
  handleChangeInputOption,
  handleDeleteInputOption,
  handleMoveGroupDown,
  handleMoveGroupUp,
  requirementsCount,
  handleMoveInput,
}) {
  const theme = useTheme();
  const { t } = useTranslation();

  const handleEditGroup = () => {
    handleTriggerEditGroup(groupIndex);
  };
  const handleDeleteGroup = () => {
    handleTriggerDeleteGroup(groupIndex);
  };
  const handleGroupDown = () => {
    handleMoveGroupDown(groupIndex);
  };
  const handleGroupUp = () => {
    handleMoveGroupUp(groupIndex);
  };
  return (
    <Box key={requirement?.name}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "block", sm: "center" },
          height: "64px",
        }}
      >
        <Box sx={{ width: "100%" }}>
          {" "}
          {/* <HomePagesMenu pageName={'Maintenance'} /> */}
          <Typography
            sx={{ mb: 0, color: theme.palette.custom.borderColor }}
            variant="subtitle"
            gutterBottom
          >
            {/* {capitalize(t('Devices'))} */}
            {t("RequirementName")}
            {":"}&nbsp;
          </Typography>
          <Typography
            sx={{ mb: 0, color: theme.palette.custom.borderColor }}
            variant="subtitle"
            gutterBottom
          >
            {/* {capitalize(t('Devices'))} */}
            {requirement.name}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", height: "64px" }}>
          <StyledBoxButton onClick={handleEditGroup}>
            <EditIcon
              sx={{
                color: theme.palette.custom.buttonTextColor,
                fontSize: 20,
              }}
            />
          </StyledBoxButton>
          <StyledBoxButton onClick={handleDeleteGroup}>
            <DeleteIcon
              sx={{
                color: theme.palette.custom.buttonTextColor,
                fontSize: 20,
              }}
            />
          </StyledBoxButton>
          <StyledBoxButton
            onClick={handleGroupDown}
            disabled={requirement.order_by === requirementsCount}
          >
            <ArrowDownwardIcon
              sx={{
                color: theme.palette.custom.buttonTextColor,
                fontSize: 20,
              }}
            />
          </StyledBoxButton>
          <StyledBoxButton
            onClick={handleGroupUp}
            disabled={requirement.order_by === 1}
          >
            <ArrowUpwardIcon
              sx={{
                color: theme.palette.custom.buttonTextColor,
                fontSize: 20,
              }}
            />
          </StyledBoxButton>
          <StyledButton
            variant="contained"
            onClick={() => handleAddInput(groupIndex)}
            startIcon={<AddIcon />}
          >
            {t("AddInput")}
          </StyledButton>
        </Box>
      </Box>
      <DndProvider backend={HTML5Backend}>
        {requirement?.inputs?.map((input, index) => (<>{
          input?.status === "active" &&
          <RequirementInput
            key={input.name}
            input={input}
            index={index}
            groupIndex={groupIndex}
            handleChangeInput={handleChangeInput}
            handleDeleteInput={handleDeleteGroupInput}
            handleAddInputOption={handleAddInputOption}
            handleChangeInputOption={handleChangeInputOption}
            handleDeleteInputOption={handleDeleteInputOption}
            handleMoveInput={handleMoveInput}
          />
        }</>
        ))}
      </DndProvider>
      <Divider
        sx={{ my: "10px", backgroundColor: theme.palette.custom.borderColor }}
      />
    </Box>
  );
}
RequirementComponent.propTypes = {
  requirement: PropTypes.object.isRequired,
  requirementsCount: PropTypes.number,
  groupIndex: PropTypes.number,
  handleChangeInput: PropTypes.func,
  handleAddInputOption: PropTypes.func,
  handleChangeInputOption: PropTypes.func,
  handleDeleteInputOption: PropTypes.func,
  handleTriggerDeleteGroup: PropTypes.func,
  handleAddInput: PropTypes.func,
  handleDeleteGroupInput: PropTypes.func,
  handleTriggerEditGroup: PropTypes.func,
  handleMoveGroupDown: PropTypes.func,
  handleMoveGroupUp: PropTypes.func,
  handleMoveInput: PropTypes.func,
};
